import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
// import bkgs from '#utilities/js/rte/bkgs/bkgs.js'
// import paragraph from '#utilities/js/rte/paragraph/paragraph.js'
// import smileys from '#utilities/js/rte/smileys/smileys.js'
// import specials from '#utilities/js/rte/specials/specials.js'
// import style from '#utilities/js/rte/style/style.js'
// import command from '#utilities/js/rte/command/command.js'
import rich_text_editor from './rich_text_editor.js'

export default contract({
  // bkgs,
  // command,
  // paragraph,
  // smileys,
  // specials,
  // style,
  rich_text_editor: array([
    rich_text_editor
  ]),
})